// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { useTheme } from "@mui/material/styles";

// Vero Software components
import MKBox from "components/MKBox";

// Renders the light or dark variant of a logo to match the current color mode
function ThemedLogo({ light, dark, alt, ...rest }) {
  const { palette } = useTheme();

  return <MKBox component="img" src={palette.mode === "dark" ? dark : light} alt={alt} {...rest} />;
}

ThemedLogo.propTypes = {
  light: PropTypes.string.isRequired,
  dark: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default ThemedLogo;
